<template>
  <div class="CartView">
    <h1>購物車</h1>
    <div class="cartcontent">
      <ul>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>

        </li>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>
        </li>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>
        </li>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>
        </li>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>
        </li>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <div class="count">
              <button><i class="fas fa-minus"></i></button>
              <h6>10</h6>
              <button><i class="fas fa-plus"></i></button>
            </div>
            <h3>小計: NT 5000 元</h3>
          </div>
        </li>
      </ul>
      <!-- <div class="noProduct">
        <h2>無任何商品</h2>
        <router-link :to="{ path: '/index' }"> 立即採購 </router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
// import Header from '@/components/header.vue';

export default {
  components: {
    // Header,
  },
};
</script>

<style>
</style>
